/* ==========================================================================
   BOCA — storefront behaviour
   Rebuilt on Shopify's AJAX Cart API. The original cart.js kept lines in
   localStorage and formatted money itself; here Shopify owns the cart and the
   money formatting, and this file only reproduces the same UI and behaviour:
   add to bag opens the mini-bag, lines can be removed, subtotal and the badge
   stay in sync across sections.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.bcRoutes || {});
  var CART_ADD = routes.add || '/cart/add.js';
  var CART_CHANGE = routes.change || '/cart/change.js';
  var CART_GET = routes.cart || '/cart.js';
  var CHECKOUT_URL = routes.checkout || '/checkout';

  var moneyFormat = window.bcMoneyFormat || '€{{amount_with_comma_separator}}';

  /* ---------------------------------------------------------------- money */
  // Mirrors Shopify's own money filter so AJAX-rendered lines match the
  // server-rendered prices elsewhere on the page.
  function formatMoney(cents) {
    var value = Number(cents) || 0;

    function withCommas(num, decimals, thousands, decimal) {
      var fixed = (num / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? whole + decimal + parts[1] : whole;
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, name) {
      switch (name) {
        case 'amount': return withCommas(value, 2, ',', '.');
        case 'amount_no_decimals': return withCommas(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withCommas(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0, '.', ',');
        case 'amount_with_space_separator': return withCommas(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withCommas(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withCommas(value, 2, "'", '.');
        default: return withCommas(value, 2, ',', '.');
      }
    });
  }

  /* ----------------------------------------------------------------- util */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function getCart() {
    return fetch(CART_GET, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function t(key, fallback) {
    return (window.bcStrings && window.bcStrings[key]) || fallback;
  }

  /* ================================================================ drawer */
  var Drawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = $('[data-bc-drawer]');
      if (!this.el) return;

      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-bc-drawer-close]')) { e.preventDefault(); self.close(); }
        var remove = e.target.closest('[data-bc-remove]');
        if (remove) { e.preventDefault(); self.removeLine(remove.getAttribute('data-bc-remove')); }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.el.hidden) self.close();
      });

      // Any cart icon anywhere on the page opens the bag.
      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-bc-cart-toggle]');
        if (!toggle) return;
        e.preventDefault();
        self.open();
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = $('[data-bc-drawer-close]:not([tabindex])', this.el);
      if (close) close.focus();
      refresh();
    },

    close: function () {
      if (!this.el) return;
      this.el.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    removeLine: function (key) {
      var self = this;
      this.el.classList.add('is-busy');
      postJSON(CART_CHANGE, { id: key, quantity: 0 })
        .then(function (cart) { render(cart); })
        .catch(function () { /* leave the drawer as-is; a refresh will resync */ })
        .then(function () { self.el.classList.remove('is-busy'); });
    },

    render: function (cart) {
      if (!this.el) return;
      var body = $('[data-bc-drawer-body]', this.el);
      var subtotal = $('[data-bc-subtotal]', this.el);
      if (!body) return;

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="bc-drawer__empty">' + escapeHtml(t('empty', 'Your bag is empty.')) + '</p>';
      } else {
        body.innerHTML = cart.items.map(function (item) {
          var img = item.image
            ? '<img src="' + escapeHtml(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x140$1$2')) +
              '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="70" height="70">'
            : '';
          var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<span class="bc-line__meta">' + escapeHtml(item.variant_title) + '</span>'
            : '';
          return '' +
            '<div class="bc-line">' +
              '<div class="bc-line__media">' + img + '</div>' +
              '<div class="bc-line__info">' +
                '<span class="bc-line__name">' + escapeHtml(item.product_title) + '</span>' +
                variantLabel +
                '<span class="bc-line__meta">' + item.quantity + ' &times; ' + formatMoney(item.final_price) + '</span>' +
                '<button type="button" class="bc-line__remove" data-bc-remove="' + escapeHtml(item.key) + '">' +
                  escapeHtml(t('remove', 'Remove')) +
                '</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }
  };

  /* ------------------------------------------------------- shared refresh */
  function render(cart) {
    Drawer.render(cart);

    var count = cart.item_count || 0;
    $$('[data-bc-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });

    document.dispatchEvent(new CustomEvent('bc:cart:updated', { detail: cart }));
  }

  function refresh() {
    return getCart().then(render).catch(function () { /* offline — keep last known state */ });
  }

  /* ============================================================ add to bag */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-bc-atc-form]');
      if (!form) return;
      e.preventDefault();

      var button = $('[data-bc-atc]', form);
      var status = $('[data-bc-atc-status]', form);
      var idInput = $('[name="id"]', form);
      if (!idInput || !idInput.value) return;

      if (button) { button.disabled = true; }
      if (status) { status.textContent = t('adding', 'Adding…'); status.classList.remove('bc-atc-status--error'); }

      var qtyInput = $('[name="quantity"]', form);
      postJSON(CART_ADD, {
        items: [{ id: Number(idInput.value), quantity: Number(qtyInput && qtyInput.value) || 1 }]
      })
        .then(function () { return getCart(); })
        .then(function (cart) {
          render(cart);
          if (status) status.textContent = '';
          Drawer.open();
        })
        .catch(function (err) {
          if (status) {
            status.textContent = err.message || t('error', 'Could not add to bag.');
            status.classList.add('bc-atc-status--error');
          }
        })
        .then(function () { if (button) button.disabled = false; });
    });

    // The gold band at the foot of each product page reuses the hero's form.
    document.addEventListener('click', function (e) {
      var proxy = e.target.closest('[data-bc-atc-proxy]');
      if (!proxy) return;
      e.preventDefault();
      var target = document.getElementById(proxy.getAttribute('data-bc-atc-proxy'));
      if (target && target.requestSubmit) target.requestSubmit();
      else if (target) target.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bc-checkout]')) {
        e.preventDefault();
        window.location.href = CHECKOUT_URL;
      }
    });
  }

  /* =========================================================== variants */
  // Reproduces the source's swatch row: picking a finish updates the price,
  // the button label, the hero tint and the availability state.
  function initVariantPickers() {
    $$('[data-bc-variants]').forEach(function (root) {
      if (root.dataset.bcBound === '1') return;
      root.dataset.bcBound = '1';

      var data = null;
      var script = $('[data-bc-variant-data]', root);
      if (!script) return;
      try { data = JSON.parse(script.textContent); } catch (e) { return; }
      if (!data || !data.variants || !data.variants.length) return;

      var section = root.closest('[data-bc-product]') || document;
      var idInput = $('[name="id"]', section);
      var nameEl = $('[data-bc-variant-name]', root);
      var priceEl = $('[data-bc-price]', section);
      var compareEl = $('[data-bc-compare-at]', section);
      var tintEl = $('[data-bc-tint]', section);
      var buttons = $$('[data-bc-swatch]', root);
      var select = $('[data-bc-variant-select]', root);
      var atcButtons = $$('[data-bc-atc-label]', document);
      var mediaFrame = $('[data-bc-hero-image]', section);

      function apply(index) {
        var v = data.variants[index];
        if (!v) return;

        if (idInput) idInput.value = v.id;
        if (nameEl) nameEl.textContent = v.title;

        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        atcButtons.forEach(function (el) {
          var base = el.getAttribute('data-bc-atc-label');
          el.textContent = v.available
            ? base + ' — ' + formatMoney(v.price)
            : t('sold_out', 'Sold out');
          var btn = el.closest('button');
          if (btn) btn.disabled = !v.available;
        });

        if (tintEl && v.swatch) tintEl.style.background = v.swatch;

        if (mediaFrame && v.featured_image) {
          mediaFrame.src = v.featured_image;
          mediaFrame.srcset = '';
        }

        buttons.forEach(function (b, i) { b.setAttribute('aria-checked', String(i === index)); });
        if (select) select.value = String(index);

        // Keep the URL shareable, the way a Shopify PDP normally behaves.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { apply(i); });
      });
      if (select) {
        select.addEventListener('change', function () { apply(Number(select.value)); });
      }

      // Honour ?variant= on load, otherwise fall back to the first variant.
      var initial = 0;
      var wanted = new URL(window.location.href).searchParams.get('variant');
      if (wanted) {
        data.variants.forEach(function (v, i) { if (String(v.id) === String(wanted)) initial = i; });
      }
      apply(initial);
    });
  }

  /* ============================================================== gallery */
  function initThumbs() {
    $$('[data-bc-thumbs]').forEach(function (root) {
      if (root.dataset.bcBound === '1') return;
      root.dataset.bcBound = '1';

      var section = root.closest('[data-bc-product]') || document;
      var main = $('[data-bc-hero-image]', section);
      if (!main) return;
      var thumbs = $$('[data-bc-thumb]', root);
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-bc-thumb');
          if (!full) return;
          main.src = full;
          main.srcset = '';
          thumbs.forEach(function (other) { other.setAttribute('aria-current', String(other === thumb)); });
        });
      });
    });
  }

  /* ================================================================== nav */
  var navBound = false;
  function initNav() {
    $$('[data-bc-menu]').forEach(function (menu) {
      if (menu.dataset.bcBound === '1') return;
      menu.dataset.bcBound = '1';
      var button = $('[data-bc-menu-button]', menu);
      if (!button) return;
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
      });
    });

    if (navBound) return;
    navBound = true;

    document.addEventListener('pointerdown', function (e) {
      $$('[data-bc-menu]').forEach(function (menu) {
        if (menu.contains(e.target)) return;
        var button = $('[data-bc-menu-button]', menu);
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-bc-menu-button]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var overlay = $('[data-bc-mobile-menu]');
      if (overlay && !overlay.hidden) {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
    });

    // Full-screen mobile menu.
    document.addEventListener('click', function (e) {
      var overlay = $('[data-bc-mobile-menu]');
      if (!overlay) return;
      if (e.target.closest('[data-bc-menu-open]')) {
        e.preventDefault();
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = $('[data-bc-menu-close]', overlay);
        if (close) close.focus();
      } else if (e.target.closest('[data-bc-menu-close]')) {
        e.preventDefault();
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  /* ================================================================= boot */
  function boot() {
    Drawer.init();
    initAddToCart();
    initVariantPickers();
    initThumbs();
    initNav();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-bind when the theme editor swaps a section in or out.
  document.addEventListener('shopify:section:load', function () {
    initVariantPickers();
    initThumbs();
    initNav();
    refresh();
  });

  window.BocaCart = { refresh: refresh, open: function () { Drawer.open(); }, formatMoney: formatMoney };
})();
